import { styled } from '@mui/material/styles';
import { DialogContent } from '@mui/material';

const PREFIX = 'FullScreenDialogContent';

const classes = {
  root: `${PREFIX}-root`,
};

interface FullScreenDialogContentProps {
  children: React.ReactNode;
}

const Root = styled(DialogContent)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'auto',
    padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
    gap: theme.spacing(3),
  },
}));

const FullScreenDialogContent = ({
  children,
}: FullScreenDialogContentProps) => {
  return <Root className={classes.root}>{children}</Root>;
};

export { FullScreenDialogContent };
